import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ENDPOINTS = {
  client: '/api/client/gifts-in-transit',
  vendor: '/api/vendor/pending-gifts',
  admin: '/api/admin/pending-gifts',
};

const COUNT_KEYS = {
  client: 'delivered_by_vendor_count',
  vendor: 'pending_count',
  admin: 'pending_admin_count',
};

export function usePendingGiftsMenuBadge(role, pollingInterval = 30000, companyId = null) {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!role || !ENDPOINTS[role]) return;

    try {
      const config = { withCredentials: true };
      if (role === 'admin' && companyId) {
        config.params = { company_id: companyId };
      }
      const response = await axios.get(ENDPOINTS[role], config);
      const key = COUNT_KEYS[role];
      setCount(response.data?.[key] ?? 0);
    } catch (error) {
      if (
        error?.response?.status === 401
        || error?.name === 'CanceledError'
        || error?.code === 'ERR_CANCELED'
      ) {
        setCount(0);
        return;
      }
      console.error('Error fetching pending gifts badge count:', error);
    }
  }, [role, companyId]);

  useEffect(() => {
    fetchCount();

    const interval = setInterval(fetchCount, pollingInterval);
    return () => clearInterval(interval);
  }, [fetchCount, pollingInterval]);

  return {
    count,
    refreshCount: fetchCount,
  };
}
